import styled from "styled-components";

export const StyledTextInput = styled.input`
  background: none;
  border: none;
  width: 100%;
  margin: 0;
  color: #444;
  box-sizing: border-box;
  padding: 3px 10px;
  font-family: "Muli", sans-serif;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: #cdcdcd;
  }
  :-ms-input-placeholder {
    color: #cdcdcd;
  }
`;
